import HTMLTemplate from './template.html'
import './styles.scss'
import ClientPortalAPIService from './../../../../services/api/ClientPortal/ApiService'
import Papa from 'papaparse'
import { debounce, cloneDeep, clone } from 'lodash'
import phoneCodes from './../../../../data/phone-codes.json'
import { isMobilePhone, isEmpty, isEmail } from 'validator'
import { OrganisationSettingsModal } from './../OrganisationSettingsModal/OrganisationSettingsModal'

const uniqueCountryCodes = []
phoneCodes.forEach(codeDetails => {
    if (uniqueCountryCodes.indexOf(codeDetails.PhoneCode) === -1) uniqueCountryCodes.push(codeDetails.PhoneCode)
})
uniqueCountryCodes.sort((a, b) => {
    const asIntegerA = parseInt(a, 10)
    const asIntegerB = parseInt(b, 10)

    if (asIntegerA < asIntegerB) return -1
    if (asIntegerA > asIntegerB) return 1
    return 0
})

export const CrewManagement = (() => {
    var vueComponent = {
        data() {
            return {
                phoneCodes: uniqueCountryCodes,

                displayCrewModal: false,
                isEditingCrew: false,
                currentCrewMember: null,

                editedUserID: null,
                fullName: '',
                selectedPhoneCodePrefix: '+1',
                contactNumber: '',
                email: '',
                role: '',

                hasSumbittedCrewModal: false,
                isSubmittingCrewData: false,
                isValidPhoneNumber: true,
                isValidEmail: true,

                displayBulkAddModal: false,
                crewMembersFromCSVFile: [],
                crewMembersToAdd: [],
                crewBulkUploadErrorMessage: '',
                fileInputLabel: 'Upload File',
                isLoading: false,
                crewRowsWithErrors: [],

                displayLookupCrew: false,
                crewSelected: [],
                existingClientCrew: [],
                filteresSearchClientCrew: [],
                crewLookUpSearch: '',
                hasCompletedCrewSelection: false,
                serverError: '',

                showBulkUploadSuccessMessage: false,
                bulkUploadedUsers: [],
                bulkFailedUsers: []
            }
        },
        methods: {
            async showAddCrewModal(preventClearingFormData) {
                if (!preventClearingFormData) {
                    this.resetCrewMemberForm()
                }
                
                this.displayCrewModal = true
                this.currentCrewMember = null
                this.isEditingCrew = false
                this.editedUserID = null
                this.hasSumbittedCrewModal = false

                const addCrewModalPromise = await new Promise((resolve, reject) => {
                    const observerInterval = window.setInterval(() => {
                        if (this.currentCrewMember !== null) {
                            resolve(this.currentCrewMember)
                            window.clearInterval(observerInterval)
                        } else if (this.displayCrewModal === false) {
                            reject('User has stopped adding new crew member')
                            window.clearInterval(observerInterval)
                        }
                    }, 500)
                }) 
        
                return addCrewModalPromise
            },
            async showBulkAddCrewModal() {
                this.displayBulkAddModal = true

                const addCrewModalPromise = await new Promise((resolve, reject) => {
                    const observerInterval = window.setInterval(() => {
                        if (this.crewMembersToAdd.length > 0) {
                            resolve(cloneDeep(this.crewMembersToAdd))
                            window.clearInterval(observerInterval)
                        } else if (this.displayBulkAddModal === false) {
                            reject('User has stopped bulk adding new crew members')
                            window.clearInterval(observerInterval)
                        }
                    }, 5000)
                }) 
        
                return addCrewModalPromise
            },
            async showEditCrewModal(crewDetails, preventFormUpdate) {
                this.hasSumbittedCrewModal = false
                this.displayCrewModal = true
                this.currentCrewMember = null
                this.isEditingCrew = true
                this.hasSuccessfullyEditedUser = false
                this.editedUserID = crewDetails.id

                if (!preventFormUpdate) {
                    this.resetCrewMemberForm()
                    this.fullName = crewDetails.name
                    this.selectedPhoneCodePrefix = crewDetails.phone.substr(0, crewDetails.phone.indexOf(' '))
                    this.contactNumber = crewDetails.phone.substr(crewDetails.phone.indexOf(' ') + 1)
                    this.email = crewDetails.email
                    this.role = crewDetails.role
                }

                const editCrewModalPromise = await new Promise((resolve, reject) => {
                    const observerInterval = window.setInterval(() => {
                        if (this.hasSuccessfullyEditedUser) {
                            resolve(this.currentCrewMember)
                            window.clearInterval(observerInterval)
                        } else if (this.displayCrewModal === false) {
                            this.isValidPhoneNumber = true
                            reject('User has stopped editing crew member')
                            window.clearInterval(observerInterval)
                        }
                    }, 500)
                }) 
        
                return editCrewModalPromise
            },
            async showLookupCrewModal() {
                this.displayLookupCrew = true
                this.crewSelected = []
                this.hasCompletedCrewSelection = false
                this.existingClientCrew = []
                this.filteresSearchClientCrew = []
                this.isLoading = true

                // Load current crew members
                ClientPortalAPIService.getClientCrew().then(response => {
                    // Reorder crew alphabetically based on name
                    this.existingClientCrew = response.sort((a, b) => a.name.localeCompare(b.name))
                    this.filteresSearchClientCrew = cloneDeep(this.existingClientCrew)
                    this.isLoading = false
                })

                const addCrewModalPromise = await new Promise((resolve, reject) => {
                    const observerInterval = window.setInterval(() => {
                        if (this.hasCompletedCrewSelection) {
                            resolve(cloneDeep(this.crewSelected))
                            window.clearInterval(observerInterval)
                        } else if (this.displayLookupCrew === false) {
                            reject('User has stopped crew lokup')
                            window.clearInterval(observerInterval)
                        }
                    }, 500)
                }) 
        
                return addCrewModalPromise
            },
            filterLookUpResults() {
                if (this.crewLookUpSearch === '') {
                    this.filteresSearchClientCrew = cloneDeep(this.existingClientCrew)
                } else {
                    this.filteresSearchClientCrew = this.existingClientCrew.filter(crew => {
                        return crew.name.toLowerCase().indexOf(this.crewLookUpSearch.toLowerCase()) > -1 || 
                               crew.email.toLowerCase().indexOf(this.crewLookUpSearch.toLowerCase()) > -1
                    })
                }
            },
            // Once a controller saves the crew, we communicate it back to this View
            communicateCrewSubmission(bulkUploadedUsers, bulkFailedUsers) {
                this.isSubmittingCrewData = false
                this.displayCrewModal = false
                this.hasSumbittedCrewModal = false
                this.crewMembersToAdd = []
                this.displayBulkAddModal = false
                this.isLoading = false
                if (this.$refs.crewFile !== undefined) this.$refs.crewFile.value = ''
                this.fileInputLabel = 'Upload File'
                this.crewMembersFromCSVFile = []
                this.displayLookupCrew = false
                this.crewSelected = []
                this.hasCompletedCrewSelection = false
                this.bulkUploadedUsers = []
                this.bulkFailedUsers = []
                this.resetCrewMemberForm()

                if (!!bulkUploadedUsers && !!bulkFailedUsers) {
                    this.bulkUploadedUsers = bulkUploadedUsers
                    this.bulkFailedUsers = bulkFailedUsers 
                    this.showBulkUploadSuccessMessage = true 
                }
            },
            communicateCrewSubmissionServerError(error) {
                this.isSubmittingCrewData = false
                this.isLoading = false
                this.serverError = error
            },
            resetCrewMemberForm() {
                this.currentCrewMember = null
                this.fullName = ''
                this.selectedPhoneCodePrefix = '+1'
                this.contactNumber = ''
                this.email = ''
                this.role = ''
                this.isValidPhoneNumber = true
                this.isValidEmail = true
            },
            saveCrewMember() {
                this.hasSumbittedCrewModal = true

                if (isEmpty(this.fullName)) return false

                // Do phone number validation
                this.isValidPhoneNumber = true 

                this.contactNumber = '' + this.contactNumber.trim()

                if (isEmpty(this.contactNumber) || this.contactNumber.length <= 7) return false
                
                const completePhoneNumber = this.selectedPhoneCodePrefix + ' ' +  this.contactNumber
                const completePhoneNumberNoSpaces = (this.selectedPhoneCodePrefix + this.contactNumber).replaceAll(' ', '')
                const isMobilePhoneNumber = isMobilePhone(completePhoneNumberNoSpaces, 'any', { strictMode: true })
                if (!isMobilePhoneNumber) {
                    this.isValidPhoneNumber = false
                    return false
                }

                // Email validation
                const emailValidationResult = this.revalidateEmail()
                if (!emailValidationResult) return false

                this.isSubmittingCrewData = true

                // Role is not mandatory, at this stage we can return the object with valid user information
                this.currentCrewMember = {
                    Name: this.fullName,
                    Phone: completePhoneNumber,
                    Email: this.email,
                    Role: this.role
                }

                if (this.isEditingCrew) {
                    this.currentCrewMember.Id = this.editedUserID
                    this.hasSuccessfullyEditedUser = true
                }
            },
            revalidateEmail() {
                this.isValidEmail = true
                this.email = this.email.trim()
                if (isEmpty(this.email)) return false
                if (!isEmail(this.email)) {
                    this.isValidEmail = false
                    return false
                }

                return true
            },
            onFileUpload($event) {
                if ($event.target.files.length === 0) {
                    this.fileInputLabel = 'Upload File'
                } else {
                    this.fileInputLabel = $event.target.files[0].name
                    this.loadCrewFromFile()
                }
            },
            loadCrewFromFile() {
                const uploadedFile = this.$refs.crewFile.files[0]
                const reader = new FileReader()

                // It's a little tricky to do front-end valdation of CSV files, I think we will make few assumptions. For more info:
                // About MIME type validation: https://stackoverflow.com/a/42140178/2052173
                const allowedFileTypes = ['text/plain', 'application/vnd.ms-excel', 'text/x-csv', 'application/csv', 'application/x-csv', 'text/csv', 'text/comma-separated-values', 'text/x-comma-separated-values', 'text/tab-separated-values']

                if (uploadedFile === undefined) {
                    this.crewBulkUploadErrorMessage = 'File input is a required field'
                    return false
                }

                if (allowedFileTypes.indexOf(this.$refs.crewFile.files[0].type) === -1) {
                    this.crewBulkUploadErrorMessage = 'You have uploaded an unsupported filetype. Please ensure you are uploading a .CSV file with standard formatting.'
                    return false
                }

                reader.onload = (event) => {
                    const papaParseResults = Papa.parse(event.target.result, {
                        skipEmptyLines: true
                    })

                    if (papaParseResults.errors.length > 0) {
                        if (papaParseResults.errors[0].type === 'Delimeter') {
                            this.crewBulkUploadErrorMessage = papaParseResults.errors[0].message
                        } else {
                            this.crewBulkUploadErrorMessage = 'There was an error parsing the file, please ensure you follow the format specified in the example CSV file.'
                        }

                        return false
                    }
                    
                    if (papaParseResults.data.length <= 1) {
                        this.crewBulkUploadErrorMessage = 'Could not find any crew memebers in the file. Please ensure you have included required headers and followed the format provided in the example CSV file.'
                        return false
                    }
                    
                    console.log('Result of the parsed file from Papaparse', papaParseResults)

                    if (!!papaParseResults.data) {
                        this.crewMembersFromCSVFile = []
                        let crewRowsWithErrors = []

                        for (let index = 1; index < papaParseResults.data.length; index++) {
                            const CSVLine = papaParseResults.data[index]

                            if (isEmpty(CSVLine[0])) crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Empty name field`)
                            else if (isEmpty(CSVLine[1])) crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Empty phone prefix field`)
                            else if (isEmpty(CSVLine[2])) crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Empty phone field`)
                            else if (!isMobilePhone('+' + CSVLine[1] + CSVLine[2].replaceAll(' ', ''), 'any', { strictMode: true })) {
                                crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Not a valid phone number.`)
                            }
                            else if (isEmpty(CSVLine[3])) crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Empty email field`)
                            else if (!isEmail(CSVLine[3])) crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Invalid email field`)
                            else {
                                // Check if there was already a user parsed with the same email or phone number
                                let fullPhoneNumber = '+' + CSVLine[1] + ' ' + CSVLine[2]
                                let alreadyParsedUserWithDuplicatePhone = this.crewMembersFromCSVFile.some(crew => crew.Phone === fullPhoneNumber)
                                let alreadyParsedUserWithDuplicateEmail = this.crewMembersFromCSVFile.some(crew => crew.Email === CSVLine[3])

                                if (alreadyParsedUserWithDuplicatePhone) {
                                    crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Duplicate phone number. There is already a user with the same phone number.`)
                                } else if (alreadyParsedUserWithDuplicateEmail) {
                                    crewRowsWithErrors.push(`Row n. ${index + 1}, reason: Duplicate email. There is already a user with the same email address.`)
                                } else {
                                    this.crewMembersFromCSVFile.push({
                                        Name: CSVLine[0],
                                        Phone: fullPhoneNumber,
                                        Email: CSVLine[3],
                                        Role: CSVLine[4]
                                    })
                                }
                            }
                        }

                        this.crewRowsWithErrors = crewRowsWithErrors
                    }
                }

                reader.readAsText(uploadedFile)
            },
            submitCrewData() {
                this.isSubmittingCrewData = true
                this.crewMembersToAdd = this.crewMembersFromCSVFile
            },
            openOrganisationalSettings() {
                this.displayLookupCrew = false
                OrganisationSettingsModal.show('Crew')
            },
            addSelectedCrew() {
                this.isLoading = true
                this.crewSelected = this.filteresSearchClientCrew.filter(crew => crew.isChecked)
                this.hasCompletedCrewSelection = true
            },
            getCrewListFilePath() {
                if (window.location.hostname === 'localhost') {
                    return 'https://localhost:44318/resources/files/crew-list.csv'
                } else {
                    return '/resources/files/crew-list.csv'
                }
            },
            clearInputFile(event) {
                event.target.value = ''
                this.fileInputLabel = 'Upload File'
                this.crewMembersFromCSVFile = []
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-crew-management')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();